import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_106: DocMigration = {
  maxSchemaVersion: "0.0.106",
  description: "New exterior trim settings",
  apply(json: any) {
    // exterior trim settings
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type !== "EXTERIOR_TRIM_SETTINGS") {
        continue;
      }

      if (settings.enableCornerMoulding !== undefined) {
        settings.enableOutsideCornerMoulding = settings.enableCornerMoulding;
        delete settings.enableCornerMoulding;
      }
    }

    return json;
  },
};

export default migration_0_0_106;
